import {
  type LibraryMemberWithInfo,
  type WorkspaceMemberResponseWithRoles,
  WorkspaceMemberType,
  type WorkspaceUserRole,
} from '@air/api/types';

export const sortMembersByRole = <T extends WorkspaceMemberResponseWithRoles | LibraryMemberWithInfo>(
  members: T[],
  roles: WorkspaceUserRole[],
) =>
  [...members].sort((a, b) => {
    if (a.type === WorkspaceMemberType.guest && b.type === WorkspaceMemberType.guest) {
      return 0;
    }

    if (a.type === WorkspaceMemberType.guest) {
      return 1;
    }

    if (b.type === WorkspaceMemberType.guest) {
      return -1;
    }

    const aRole = roles.find((r) => r.id === a.roleId);
    const bRole = roles.find((r) => r.id === b.roleId);

    return aRole && bRole ? aRole?.sortOrder - bRole?.sortOrder : 0;
  });
